/**
 * PDP App control — scroll parallax (desktop):
 * - Image 2 (bottom): scrolls down with lower speed
 * - Image 1 (top): scrolls up with double the speed of Image 2
 * Wrapper: .pdp-app-control__parallax; images: .pdp-app-control__img-scroll-top, .pdp-app-control__img-scroll
 * Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  /** Image 2 (bottom) movement strength — scrolls down, lower speed */
  var IMAGE2_SPEED = 16;
  /** Image 1 (top) = 2× Image 2 — scrolls up, double speed */
  var IMAGE1_SPEED = IMAGE2_SPEED * 2;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initParallax() {
    if (prefersReducedMotion()) return;

    var wrappers = document.querySelectorAll('.pdp-app-control__parallax');
    if (!wrappers.length) return;

    wrappers.forEach(function (section) {
      var imgTop = section.querySelector('.pdp-app-control__img-scroll-top');
      var imgScroll = section.querySelector('.pdp-app-control__img-scroll');
      if (!imgTop || !imgScroll) return;

      var ticking = false;

      function updateParallax() {
        var rect = section.getBoundingClientRect();
        var windowHeight = window.innerHeight;
        var sectionTop = rect.top;
        var sectionHeight = rect.height;

        if (sectionTop < windowHeight && sectionTop + sectionHeight > 0) {
          var progress = (windowHeight - sectionTop) / (windowHeight + sectionHeight);
          /* Image 1: scroll up (negative Y) at double speed */
          var offset1 = (progress - 0.5) * IMAGE1_SPEED;
          /* Image 2: scroll down (positive Y) at lower speed */
          var offset2 = (0.5 - progress) * IMAGE2_SPEED;
          imgTop.style.transform = 'translate3d(0px, ' + offset1 + '%, 0px)';
          imgScroll.style.transform = 'translate3d(0px, ' + offset2 + '%, 0px)';
        }

        ticking = false;
      }

      function onTick() {
        if (!ticking) {
          requestAnimationFrame(function () {
            updateParallax();
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onTick, { passive: true });
      window.addEventListener('resize', onTick);
      updateParallax();
    });
  }

  function init() {
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
